const scheduledServicesPlannerHeader = {
  scheduledServices: "Scheduled Services",
};

export default scheduledServicesPlannerHeader;
